import { SET_CMP_CONSENT_ACTIVE_GROUPS_FROM_COOKIE } from '@/store/mutation-types'
import Cookies from 'js-cookie'
import { CMP_CONSENT_COOKIE_NAME } from 'enums/cmp'

export default function({ store }) {
  if (process.server) return

  store.commit(
    `cmp/${SET_CMP_CONSENT_ACTIVE_GROUPS_FROM_COOKIE}`,
    Cookies.get(CMP_CONSENT_COOKIE_NAME)
  )
}
